import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=6773f706&scoped=true&"
import script from "./CardProduct.vue?vue&type=script&lang=js&"
export * from "./CardProduct.vue?vue&type=script&lang=js&"
import style0 from "./CardProduct.vue?vue&type=style&index=0&id=6773f706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773f706",
  null
  
)

export default component.exports